import { MatchingBonus } from "@/modules/user/types/wallet";
import { apiWithAuth } from "../authApi";
import { useApplyRefcodeStore } from "../../store/applyRefcode";
import { isAxiosError } from "axios";

export const getMatchingBonus = async (
  network: "TON" | "EVM" | undefined = undefined,
  chainId: number | undefined = undefined
): Promise<MatchingBonus | undefined> => {
  try {
    const params = new URLSearchParams();

    if (network) params.append("network", network);
    if (chainId) params.append("chainId", chainId.toString());

    const response = await apiWithAuth.get(
      `/user/deposit/reward/bonuses?${params.toString()}`
    );

    const data = response.data as MatchingBonus;

    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      const { setIsReferralError } = useApplyRefcodeStore.getState();
      type ErrorResponse = { message?: string; error?: string };
      const message =
        (error.response?.data as ErrorResponse)?.error || error.message || "";

      if (message.includes("Referral not found")) {
        setIsReferralError(true);
      }
    }
    return undefined;
  }
};

export const postMatchingBonus = async (
  withdrawalType: "ton" | "token",
  network: "TON" | "EVM" | undefined = undefined,
  chainId: number | undefined = undefined
): Promise<unknown | undefined> => {
  try {
    const response = await apiWithAuth.post(
      "/user/withdraw/deposit/reward/bonuses",
      {
        withdrawalType,
        network,
        chainId,
      }
    );

    const data = response.data;

    return data;
  } catch (error) {
    return undefined;
  }
};
